import FilterLocationModal from './FilterLocationModal';
export default FilterLocationModal;